<template>
  <div>
    <b-message>
      <b>{{ title }}</b>
    </b-message>

    <button class="button is-light btn-margin" @click.prevent="cancel()">
      Back to games list
    </button>
    <button class="button is-light btn-margin" @click.prevent="refreshData()" style="margin-left: 10px">
      Refresh map
    </button>

    <div style="margin-bottom: 10px">&nbsp;
      <li>Red pins: challenges of this game.</li>
      <li>Blue rectangles: last known location of the each team.</li>
      <em style="font-size: 0.8em">If no blue rectangles are displayed, it means no teams played yet or they played more than 1h ago since the system keeps geoloc data only during 1h.</em>
    </div>

    <div :v-if="!isLoading">
      <map-previewer :center="center" :mapType="mapType" :markers="markers" ref="map_previewer" :height="600">

      </map-previewer>
    </div>

    <div>&nbsp;</div>

    <button class="button is-light btn-margin" @click.prevent="cancel()">
      Back to games list
    </button>
    <button class="button is-light btn-margin" @click.prevent="refreshData()" style="margin-left: 10px">
      Refresh map
    </button>

    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
  </div>
</template>

<script>
import gamesService from '../services/gamesService'
import MapPreviewer from './single/MapPreviewer'
import displayHelper from '../helpers/display-helper'

export default {
  data() {
    return {
      error: '',
      gameId: '',
      isLoading: true,
      title: '',
      center: {lat: 1.3581036, lng: 103.8329625},
      markers: [],
      mapType: 'satellite'
    }
  },
  components: {
    MapPreviewer
  },

  async created() {
    if (this.$route.params.id) {
      this.gameId = this.$route.params.id
      this.game = await gamesService.getGameById(this.gameId)
      this.displayTitle()
      await this.refreshData()
    }
    this.isLoading = false
  },

  methods: {
    displayTitle() {
      this.title = `Game preview: ${this.game.gameName}`
    },
    async refreshData() {
      try {
        if (this.$route.params.id) {
          this.isLoading = true
          this.markers = await gamesService.getGameMarkers(this.gameId)
          this.isLoading = false
        } else {
          displayHelper.displayError(this, 'GameId was not found in URL')
          this.displayErrors(['Oops - GameId was not found in URL'])
        }
      } catch (err) {
        displayHelper.displayError(this, 'Failed to display preview for this game - please contact support')
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>
